export default __webpack_public_path__ + "static/community_3-d76b64fc77e32cb834c50650b92b3ff3.jpg";